<template>
  <div class="progress-bars">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="progress-bar-container"
      :style="{ flex: backgroundFlex[index] }"
      :title="getTooltip(index)"
    >
      <div class="progress-bar-background">
        <div
          class="progress-bar-fill"
          :style="{
            width: calculateFillWidth(index, item.value) + '%',
            backgroundColor: colors[index % colors.length],
          }"
        ></div>
        <div class="progress-label">{{ item.value }}</div>
      </div>
    </div>

    <!-- Total -->
    <div class="progress-bar-container total-column">
      <div class="progress-bar-background no-bar">
        <div class="progress-label total-value">{{ totalData }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBars',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      colors: ['#3498db', '#3498db'],
      backgroundFlex: [3, 7],
    }
  },
  computed: {
    totalData() {
      return this.items.reduce((sum, item) => sum + (item.value || 0), 0)
    },
  },
  methods: {
    calculateFillWidth(index, data) {
      const ranges = [3, 7]
      const range = ranges[index] || 1
      const value = Math.max(0, data)
      return Math.max(0, Math.min(100, (value / range) * 100))
    },
    getTooltip(index) {
      const tooltips = ['Escore Vínculo', 'Escore Acompanhamento']
      return tooltips[index] || ''
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-bars {
  display: flex;
  gap: 4px;
  margin: 15px 0;

  .progress-bar-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    .progress-bar-background {
      position: relative;
      width: 100%;
      height: 24px;
      background-color: #f2f2f2;
      overflow: hidden;
      border-radius: 4px;

      &.no-bar {
        background-color: transparent;
        border: none;
      }

      .progress-bar-fill {
        height: 100%;
        transition: width 0.3s ease-in-out;
        position: absolute;
        top: 0;
        left: 0;
      }

      .progress-label {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;
        font-weight: bold;
        white-space: nowrap;
        pointer-events: none;
        color: #000;
      }

      .total-value {
        color: #000;
      }
    }
  }

  .total-column {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1; // ou um valor fixo pequeno, se quiser
    .progress-bar-background {
      border: 1px dashed #ccc;
      background-color: transparent;
    }

    .progress-max {
      visibility: hidden;
    }
  }
}
</style>
